import React, { useRef } from 'react'
import useSWR from 'swr'
import fetcher from '@lib/fetcher'
import Slider from 'react-slick'
import Slide from './slide'

const Slideshow = ({ id = 'homepage' }) => {
  const { data: slideshow } = useSWR(`/slideshows/${id}`, fetcher)
  const sliderRef = useRef(null)
  
  const CustomPrevArrow = () => (
    <button
      className='absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 z-10 bg-black/50 hover:bg-black/70 text-white p-1.5 sm:p-2 rounded-full transition-all duration-200 backdrop-blur-sm opacity-100 sm:opacity-0 sm:group-hover:opacity-100 focus:opacity-100'
      onClick={() => sliderRef.current?.slickPrev()}
      aria-label="Previous slide"
    >
      <svg className='w-5 h-5 sm:w-6 sm:h-6' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
        <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M15 19l-7-7 7-7' />
      </svg>
    </button>
  )

  const CustomNextArrow = () => (
    <button
      className='absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 z-10 bg-black/50 hover:bg-black/70 text-white p-1.5 sm:p-2 rounded-full transition-all duration-200 backdrop-blur-sm opacity-100 sm:opacity-0 sm:group-hover:opacity-100 focus:opacity-100'
      onClick={() => sliderRef.current?.slickNext()}
      aria-label="Next slide"
    >
      <svg className='w-5 h-5 sm:w-6 sm:h-6' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
        <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 5l7 7-7 7' />
      </svg>
    </button>
  )
  
  var settings = {
    customPaging: _slide => {
      return (
        <div className='w-2 h-2 rounded-full bg-white opacity-50 hover:opacity-100' />
      )
    },
    dots: true,
    dotsClass:
      'absolute top-2 w-full !flex flex-row justify-center align-center space-x-3',
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false // Disable default arrows since we're using custom ones
  }
  
  return (
    <div className='sm:aspect-[16/9] rounded-lg w-full h-full shadow-lg overflow-hidden relative bg-white dark:bg-gray-900 group'>
      {slideshow && slideshow.slides.length > 1 && (
        <>
          <CustomPrevArrow />
          <CustomNextArrow />
        </>
      )}
      {slideshow && (
        <Slider ref={sliderRef} {...settings}>
          {slideshow.slides.map(slide => (
            <Slide key={slide.id} slide={slide} />
          ))}
        </Slider>
      )}
    </div>
  )
}

export default Slideshow
